export default "__VITE_ASSET__CQp_rbFP__"